import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import { sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

export default class TextOnly extends Component {
  render() {
    const { text, textPosition } = this.props

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems:
            textPosition === "alto"
              ? "start"
              : textPosition === "basso"
              ? "end"
              : "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            textAlign: "center",
            textTransform: "none",
            margin: "32px",
            padding: "32px 48px",
            borderRadius: "24px",
            background: "rgba(255, 255, 255, .8)",
            backdropFilter: "blur(16px)",
            maxWidth: "min(960px, calc(100% - 160px))",
          }}
        >
          <Typography
            variant="h2"
            style={{ overflow: "hidden", textOverflow: "ellipsis" }}
            dangerouslySetInnerHTML={{
              __html: linkifyHtml(sanitizeYaml(text), {
                target: "_blank",
                attributes: {
                  class: "underlineOnHover",
                },
              }),
            }}
          />
        </div>
      </div>
    )
  }
}
